(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../_util/index'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../_util/index'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.utils = mod.exports;
  }
})(this, function (exports, _index) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.parseTimeData = parseTimeData;
  exports.parseFormat = parseFormat;
  exports.isSameSecond = isSameSecond;
  exports.ariaParseFormat = ariaParseFormat;


  var SECOND = 1000;
  var MINUTE = 60 * SECOND;
  var HOUR = 60 * MINUTE;
  var DAY = 24 * HOUR;

  function parseTimeData(time) {
    var days = Math.floor(time / DAY);
    var hours = Math.floor(time % DAY / HOUR);
    var minutes = Math.floor(time % HOUR / MINUTE);
    var seconds = Math.floor(time % MINUTE / SECOND);
    var milliseconds = Math.floor(time % SECOND);

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
      milliseconds: milliseconds
    };
  }

  function parseFormat(format, timeData) {
    var days = timeData.days;
    var hours = timeData.hours,
        minutes = timeData.minutes,
        seconds = timeData.seconds,
        milliseconds = timeData.milliseconds;


    if (format.indexOf('DD') === -1) {
      hours += days * 24;
    } else {
      format = format.replace('DD', (0, _index.padZero)(days));
    }

    if (format.indexOf('HH') === -1) {
      minutes += hours * 60;
    } else {
      format = format.replace('HH', (0, _index.padZero)(hours));
    }

    if (format.indexOf('mm') === -1) {
      seconds += minutes * 60;
    } else {
      format = format.replace('mm', (0, _index.padZero)(minutes));
    }

    if (format.indexOf('ss') === -1) {
      milliseconds += seconds * 1000;
    } else {
      format = format.replace('ss', (0, _index.padZero)(seconds));
    }

    return format.replace('SSS', (0, _index.padZero)(milliseconds, 3));
  }

  function isSameSecond(time1, time2) {
    return Math.floor(time1 / 1000) === Math.floor(time2 / 1000);
  }

  function ariaParseFormat(format, timeData) {
    var days = timeData.days;
    var hours = timeData.hours,
        minutes = timeData.minutes,
        seconds = timeData.seconds,
        milliseconds = timeData.milliseconds;


    if (format.indexOf('DD') === -1) {
      hours += days * 24;
    } else {
      format = format.replace('天', '');
      format = format.replace('DD', (0, _index.padZero)(days) + '天');
      format = format.replace('d', '');
    }

    if (format.indexOf('HH') === -1) {
      minutes += hours * 60;
    } else {
      format = format.replace('小时', '');
      format = format.replace('时', '');
      format = format.replace('HH', (0, _index.padZero)(hours) + '时');
      format = format.replace('h', '');
    }

    if (format.indexOf('mm') === -1) {
      seconds += minutes * 60;
    } else {
      format = format.replace('分钟', '');
      format = format.replace('分', '');
      format = format.replace('mm', (0, _index.padZero)(minutes) + '分');
      format = format.replace('m', '');
    }

    if (format.indexOf('ss') === -1) {
      milliseconds += seconds * 1000;
    } else {
      format = format.replace('秒', '');
      format = format.replace('ss', (0, _index.padZero)(seconds) + '秒');
      format = format.replace('s', '');
      format = format.replace('S', '');
    }
    format = format.replace(/\s/g, '');
    format = format.replace(/:/g, '');
    return format.replace('SSS', (0, _index.padZero)(milliseconds, 3));
  }
});